import React from 'react'
import css from './styles.module.scss'
import HeroTitle from 'components/typo/HeroTitle'
import Text from 'components/typo/Text'
import ContactForm from 'components/shared/ContactForm'

const ContactFormSection = ({
  upperTitle,
  title,
  description,
  contactForm,
}) => {
  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <Text className={css.upperTitle}>{upperTitle}</Text>
        <HeroTitle tag="h1">{title}</HeroTitle>
        <Text className={css.description}>{description}</Text>
      </div>
      <div className={css.contactWrapper}>
        {contactForm && <ContactForm {...contactForm} />}
      </div>
    </div>
  )
}

export default ContactFormSection
